import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const numberOnlyPattern = /^\d+$/; // NOSONAR
export const numberOnlyValid = (control: FormControl) =>
    numberOnlyPattern.test(control.value || 0) ? null : { numberOnly: messages.validation.numberOnly };
